export const buildEloquaExtraDataOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (!data) {
        return {
            csmEmail: '',
            csmName: '',
            contactOwnerMeetingLink: '',
            csOwnerMeetingLink: '',
            currentCADSystem: '',
            daysLeftInTrial: '',
            isEmailPreferencesSet: false,
            isSubBlogs: false,
            isSubEvents: false,
            isSubNewsletter: false,
            isSubPremiumContent: false,
            jobTitleNormalized: '',
            productSku: '',
            productSkuAtSignup: '',
            salesOpps: 0,
            salesPersonMeetingLink: '',
            uUsageTimeL30D: 0,
            uUsageTimeTotal: 0,
        };
    }
    const result = {
        jobTitleNormalized: (_a = data.jobTitleNormalized) !== null && _a !== void 0 ? _a : '',
        productSkuAtSignup: (_b = data.productSkuAtSignup) !== null && _b !== void 0 ? _b : '',
        currentCADSystem: (_c = data.currentCADSystem) !== null && _c !== void 0 ? _c : '',
        contactOwnerMeetingLink: (_d = data.contactOwnerMeetingLink) !== null && _d !== void 0 ? _d : '',
        csOwnerMeetingLink: (_e = data.csOwnerMeetingLink) !== null && _e !== void 0 ? _e : '',
        salesPersonMeetingLink: (_f = data.salesPersonMeetingLink) !== null && _f !== void 0 ? _f : '',
        salesOpps: (_g = data.salesOpps) !== null && _g !== void 0 ? _g : 0,
        csmName: (_h = data.csmName) !== null && _h !== void 0 ? _h : '',
        csmEmail: (_j = data.csmEmail) !== null && _j !== void 0 ? _j : '',
        isEmailPreferencesSet: (_k = data.isEmailPreferencesSet) !== null && _k !== void 0 ? _k : false,
        isSubPremiumContent: (_l = data.isSubPremiumContent) !== null && _l !== void 0 ? _l : false,
        isSubNewsletter: (_m = data.isSubNewsletter) !== null && _m !== void 0 ? _m : false,
        isSubEvents: (_o = data.isSubEvents) !== null && _o !== void 0 ? _o : false,
        isSubBlogs: (_p = data.isSubBlogs) !== null && _p !== void 0 ? _p : false,
        productSku: (_q = data.productSku) !== null && _q !== void 0 ? _q : '',
        daysLeftInTrial: (_r = data.daysLeftInTrial) !== null && _r !== void 0 ? _r : '',
        uUsageTimeL30D: (_s = data.uUsageTimeL30D) !== null && _s !== void 0 ? _s : 0,
        uUsageTimeTotal: (_t = data.uUsageTimeTotal) !== null && _t !== void 0 ? _t : 0,
    };
    return result;
};
